import { declareString } from "@1js/localization";

export const PromptLibraryDialogClose = declareString(
  "promptLibrary.promptLibraryDialogClose",
  {
    text: "Close Dialog",
    comment:
      "Label for the close button in the prompt library dialog. User uses this button to close the dialog",
  }
);
